import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  paymentStatus: false,
};

const paymentStatusSlice = createSlice({
  name: "Save the payment status",
  initialState,
  reducers: {
    updatePaymentStatus(state, action) {
      state.paymentStatus = action.payload.paymentStatus;
    },
    resetPaymentStatus(state) {
      state.paymentStatus = false;
    },
  },
});

export const { updatePaymentStatus, resetPaymentStatus } = paymentStatusSlice.actions;
export default paymentStatusSlice.reducer;
